export const getUser = (userId) => ({ users: { usersList } }) =>
  usersList.find(({ id }) => id === +userId);
